import React from "react";
import { AuthoringTinyEditor } from "modules/common/components/authoring/authoringTinyMce";
import { connect, ConnectedProps } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";
import { useTinyMceAuthoringLogic } from "modules/common/hooks/useTinyMceAuthoringLogic";
import * as galleryActions from "modules/gallery/actionCreator";
import ImageGalleryDialog from "modules/common/components/authoring/dialogs/imageGalleryDialog";
import IntenseEmphasis from "modules/events/components/dialogs/intenseEmphasis";
import { RawEditorOptions } from "tinymce";

interface NewsletterHeaderFooterEditorProps {
    initOptions: (RawEditorOptions & { selector?: undefined; target?: undefined; });
    enableEmbeddedMedia: boolean;
    enableInlineImages: boolean;
    value: string;
    changedSinceSaved: boolean;
    defaultLcid: string;
    onChange: (value: string) => void;
    onFullscreen?: (isFullscreen: boolean) => void;
}

const NewsletterHeaderFooterEditor: React.FC<PropsWithRedux> = ({
    initOptions,
    enableEmbeddedMedia,
    enableInlineImages,
    value,
    changedSinceSaved,
    defaultLcid,
    onChange,
    onFullscreen,
    getImage,
}) => {
    const {
        editorRef,
        intenseEmphasisDialogOpen,
        inlineImageDialogOpen,
        onApplyInlineImage,
        onShowIntenseEmphasisDialog,
        onApplyIntenseEmphasis,
        onHideIntenseEmphasisDialog,
        onShowInlineImageDialog,
        onHideInlineImageDialog,
    } = useTinyMceAuthoringLogic(getImage);

    return (
        <>
            <AuthoringTinyEditor
                initOptions={initOptions}
                enableEmbeddedMedia={enableEmbeddedMedia}
                enableInlineImages={enableInlineImages}
                value={value}
                editorMaxWidth={540}
                changedSinceSaved={changedSinceSaved}
                onChange={onChange}
                defaultLcid={defaultLcid}
                editorRef={editorRef}
                onShowIntenseEmphasisDialog={onShowIntenseEmphasisDialog}
                onShowInlineImageDialog={onShowInlineImageDialog}
                onFullscreen={onFullscreen}
            />
            <ImageGalleryDialog show={inlineImageDialogOpen} allowLink onApply={(selected) => onApplyInlineImage(selected)} onClose={onHideInlineImageDialog} />
            <IntenseEmphasis show={intenseEmphasisDialogOpen} onApply={onApplyIntenseEmphasis} onClose={onHideIntenseEmphasisDialog} />
        </>
    );
};

const connector = connect(
    (state: GlobalApplicationState, ownProps: NewsletterHeaderFooterEditorProps) => ({
        ...ownProps,
        defaultLcid: state.settings.tenantSettings.defaultLCID,
    }),
    {
        getImage: galleryActions.getImage,
    }
);

type PropsWithRedux = ConnectedProps<typeof connector>;

export default NewsletterHeaderFooterEditor;